import {
  type ParentBreadcrumb,
  type SectionConfig
} from '@/utils/get-matched-section'

const apDesignerParent: ParentBreadcrumb = {
  label: 'AP Designer',
  href: (_params, orgSlug) => `/${orgSlug}/design/ap-designer`
}

export const sectionConfig: SectionConfig = {
  '/design/queue': {
    title: 'Design Queue',
    showBreadcrumbs: false
  },
  '/design/tasks': {
    title: 'Design Tasks'
  },
  '/design/settings': {
    title: 'Design Settings'
  },
  '/design/settings/import': {
    title: 'Import from Hive',
    parentBreadcrumb: {
      label: 'Settings',
      href: (_params, orgSlug) => `/${orgSlug}/design/settings`
    }
  },
  '/design/tasks/[taskId]': {
    title: 'Design Task',
    parentBreadcrumb: {
      label: 'Queue',
      href: (_params, orgSlug) => `/${orgSlug}/design/queue`
    }
  },
  '/design/ap-designer': {
    title: 'AP Designer'
  },
  '/design/ap-designer/feedback': {
    title: 'AP Designer Feedback',
    parentBreadcrumb: apDesignerParent
  },
  '/design/ap-designer/conventions': {
    title: 'AP Designer Conventions',
    parentBreadcrumb: apDesignerParent
  },
  // The floor editor is a canvas that owns its own height and scroll.
  '/design/ap-designer/[propertyId]': {
    title: 'AP Design',
    parentBreadcrumb: apDesignerParent,
    fullBleed: true
  }
}
